// removed by extract-text-webpack-plugin
module.exports = {"footer":"_31xbU_g0hq9YzSWczPjP3Q_1"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_1","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-rewriter.js?id=data-v-b262d57c!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/App.vue
// module id = 68
// module chunks = 2